<template>
    <div class="policies">
        <div class="table">
            <div class="table__header box box--default">
                <div class="table__label table__label--small">
                    {{
                        $t(`accountDetails.${"customerLeadsTable"}.${"header"}.${"date"}`)
                    }}
                </div>
                 <div class="table__label table__label--small">
                    Status
                </div>
                <div class="table__label table__label--medium">
                    {{
                        $t(
                            `accountDetails.${"customerLeadsTable"}.${"header"}.${"category"}`
                        )
                    }}
                </div>
                <div class="table__label table__label--small">
                    {{
                        $t(
                            `accountDetails.${"customerLeadsTable"}.${"header"}.${"referal"}`
                        )
                    }}
                </div>
                 <div class="table__label table__label--medium">
                    {{
                        $t(
                            `accountDetails.${"customerLeadsTable"}.${"header"}.${"agent"}`
                        )
                    }}
                </div>
                <div class="table__label table__label--small">
                    {{
                        $t(
                            `accountDetails.${"customerLeadsTable"}.${"header"}.${"contact"}`
                        )
                    }}
                </div>
                <div class="table__label table__label--small">
                    {{
                        $t(`accountDetails.${"customerLeadsTable"}.${"header"}.${"deadline"}`)
                    }}
                </div>
                <div class="table__label table__label--large">
                    {{
                        $t(`accountDetails.${"customerLeadsTable"}.${"header"}.${"text"}`)
                    }}
                </div> 
                <div class="table__label table__label--small  "></div>
            </div>

            <div class="table__body">
                <Loading v-if="detailsLoading" />
                <template v-else>
                    <div v-if="!leadsData.length" class="table__no-data">
                        <NoData :type="'customer-leads'" />
                    </div>
                    <template v-else>
                        <Lead v-for="(lead, index) in leadsData" :key="lead.id" :lead="lead" :index="index" />
                    </template>
                </template>
            </div>
        </div>
        <Pagination :limit="3" :data="leadsPerPage" @pagination-change-page="getResults"></Pagination>
    </div>
</template>

<script>
import NoData from "@/partials/NoData";
import Loading from "@/partials/Loading";
import Lead from "@/components/AccountDetails/Lead";
import { mapGetters } from "vuex";
export default {
    name: "CustomerLeadsTable",

    components: {
        NoData,
        Loading,
        Lead,
    },

    data() {
        return {
            detailsLoading: false,
            lastFetchedCustomerId: null, // Track which customer data was fetched for
            lastFetchedPage: null, // Track which page was fetched
        };
    }, 

    computed: {
        ...mapGetters(["leadsPerPage", "customerDetails"]), 
        
        customerId() {
            return this.$store.getters.customerDetailsId;
        },

        leadsData() {
            return this.leadsPerPage.data || [];
        }
    },

    watch: {
        "$route.query": {
            handler(query, oldQuery) {
                // Only trigger if query actually changed and component is fully initialized
                if (this.customerId && oldQuery && query.page !== oldQuery.page) {
                    if (!query.page) {
                        this.$router.replace({ query: { ...query, page: 1 } });
                        return;
                    }
                    this.loadLeads();
                }
            },
            deep: true,
        },
    },

    methods: {
        async loadLeads() {
            const page = Number(this.$route.query.page) || 1;
            
            // Only fetch if customer or page changed
            if (this.lastFetchedCustomerId === this.customerId && this.lastFetchedPage === page) { 
                return;
            }

            this.detailsLoading = true;
            try {
                if (this.customerId) {
                    await this.$store.dispatch("fetchLeads", { customerId: this.customerId, page });
                    this.lastFetchedCustomerId = this.customerId; // Mark as fetched
                    this.lastFetchedPage = page;

                    if (this.$route.params.entity === "lead" && this.leadsData.length === 0) {
                        this.$store.commit("setShowAddLeadModal", true);
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.detailsLoading = false;
            }
        },

        getResults(paginationPage) {
            if (Number(this.$route.query.page) === Number(paginationPage)) return;

            this.$router.replace({
                query: { ...this.$route.query, page: paginationPage },
            }).catch(() => { });
        },
    },

    async mounted() { 
        if (!(this.$checkRolePermission('customer_access') || this.$checkRolePermission('customer_show'))) {
            this.$router.push('/dashboard');
        } else{
            if (this.customerDetails && this.customerDetails.id) {
                const query = this.$route.query;
                if (!query.page) {
                    this.$router.replace({ query: { ...query, page: 1 } });
                } else {
                    await this.loadLeads();
                }
                return;
            }
    
            const unwatch = this.$watch(
                () => this.customerDetails,
                async (newVal) => {
                    if (newVal && newVal.id) {
                        unwatch();
                        const query = this.$route.query;
                        if (!query.page) {
                            this.$router.replace({ query: { ...query, page: 1 } });
                        } else {
                            await this.loadLeads();
                        }
                    }
                }
            );
        }
    },
};
</script>

<style scoped lang="scss">
.policies .table__label:first-of-type {
    padding: 2px 10px !important;
}
</style>
